import { useCallback, useEffect, useRef, useState } from "react";
import { HbrArrowLeft, HbrArrowRight } from "./newComponents/Mycustomsvgicons";

const ImageSlider = ({slides}) => {
 const[currentIndex,setCurrentIndex] = useState(0);
 const timerRef = useRef(null);

  const PreviousImage = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    
  };

  const NextImage = useCallback(() => {
    const isLastSlide = currentIndex === slides.length -1;
    const newIndex = isLastSlide? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  },[currentIndex,slides.length]);

  // const specificSlide =(slideIndex) =>{
  //    setCurrentIndex(slideIndex);
  // };

  useEffect(() => {
    if(timerRef.current){
      clearTimeout(timerRef.current);
    }
  // console.log("use effect")
    timerRef.current = setTimeout(() => {
      NextImage();
    },4000);

    return () => clearTimeout(timerRef.current);

  },[NextImage]);

    return ( 
    
    <div className="Image-slides" >
        <div  style={{backgroundImage: `url(${slides[currentIndex]?.pic})`
                                    //  width:"100%",
                                    //  height:"100%",
                                    //  backgroundPosition: "center",
                                    // backgroundSize: "70%"
                                  }}  className="imageStyles">
        <div className="leftarrowstyle" onClick={PreviousImage}> <HbrArrowLeft width="2em" height="2em" fillColour="white" /> </div>
        <div className="rightarrowstyle"  onClick={NextImage}><HbrArrowRight width="2em" height="2em" fillColour="white" /></div>
        <div className="dotsContainerStyles">
         
         {/* <div className="dotstylesContainer">
         {slides.map((slide,slideIndex) => (
            <div className="dotstyles" key={slideIndex} onClick={() => specificSlide(slideIndex)}>
              ⚈
            </div>
          ))}
         </div> */}
        </div>
        </div>
      
    </div> 
    );
}
 
export default ImageSlider;